import TessellInput from 'common/custom-components/lib/components/TessellInput';
import { useCloudCommands } from './useCloudCommands';
import { IconButton, MenuItem, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { styles } from 'assets/scss/style-templates';
import { cloudCommandsStyles } from './styles';
import { Delete } from '@mui/icons-material';

const CloudCommands = ({ tenant }) => {
  const {
    output,
    command,
    dropDownOptionsData,
    selectedSubscription,
    isLoading,
    selectedCloud,
    selectedRegion,
    setSelectedRegion,
    setCommand,
    handleCommand,
    setSelectedCloud,
    setSelectedSubscription,
    clearScreen,
  } = useCloudCommands({ tenant });

  return (
    <Stack>
      <Stack direction="row">
        <TessellInput
          filter
          margin={'none'}
          label="Subscription"
          labelStyles={styles.filterLabel}
          width="30%"
          variant="standard"
          size="small"
          name="subscription"
          select
          mr={2}
          value={selectedSubscription}
          onChange={(e) => setSelectedSubscription(e.target.value)}
          options={(dropDownOptionsData?.subscriptionOptions || []).map((v) => (
            <MenuItem key={v?.id} value={v?.label}>
              {v?.label}
            </MenuItem>
          ))}
        />
        <TessellInput
          filter
          margin={'none'}
          label="Cloud"
          labelStyles={styles.filterLabel}
          width="30%"
          variant="standard"
          size="small"
          name="cloud"
          select
          mr={2}
          value={selectedCloud}
          disabled={!selectedSubscription}
          onChange={(e) => {
            setSelectedCloud(e.target.value);
          }}
          options={(
            dropDownOptionsData?.subscriptionToCloudMap?.[
              selectedSubscription
            ] || []
          ).map((v) => (
            <MenuItem key={v.cloudAccountId} value={v.cloudAccountId}>
              {v.cloud}
            </MenuItem>
          ))}
        />
        <TessellInput
          filter
          margin={'none'}
          defaultValue={'All'}
          label="Region"
          labelStyles={styles.filterLabel}
          width="30%"
          variant="standard"
          size="small"
          name="region"
          select
          mr={2}
          value={selectedRegion}
          disabled={!selectedSubscription || !selectedCloud}
          onChange={(e) => {
            setSelectedRegion(e.target.value);
          }}
          options={(
            dropDownOptionsData?.cloudAccountIdToRegionsMap?.[selectedCloud] ||
            []
          )?.map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        />
      </Stack>
      <Stack direction={'row'} sx={cloudCommandsStyles.commandRow}>
        <TessellInput
          label="Command"
          value={command}
          variant="outlined"
          size="small"
          onKeyDown={(ev) => {
            if (ev.key === 'Enter') {
              handleCommand();
              ev.preventDefault();
            }
          }}
          onChange={(e) => setCommand(e.target.value)}
          sx={cloudCommandsStyles.commandInput}
          placeholder={`Example: aws ec2 describe-instances  --query "Reservations[*].Instances[*].InstanceId"`}
        />
        <LoadingButton
          loading={isLoading}
          disabled={!command.trim() || !selectedCloud || !selectedRegion}
          onClick={handleCommand}
          variant="contained"
          size="large"
          sx={cloudCommandsStyles.createButton}
        >
          Execute
        </LoadingButton>
      </Stack>
      <Stack sx={cloudCommandsStyles.console}>
        <Stack sx={cloudCommandsStyles.deleteIconContainer}>
          <IconButton onClick={clearScreen} disabled={!output.length}>
            <Delete
              sx={{
                fontSize: '24px',
                color: !output.length
                  ? styles.color.monotoneDarkDark
                  : styles.color.darkShade,
              }}
            />
          </IconButton>
        </Stack>
        {output.map((command, index) =>
          Array.isArray(command[0]) ? (
            command[0].map((commnd) => (
              <Typography
                key={commnd}
                sx={{
                  ...cloudCommandsStyles.commandBox,
                  color:
                    command?.[1] === 200
                      ? 'green'
                      : command?.[1] === null
                      ? 'green'
                      : 'red',
                  fontWeight: command?.[1] === null ? 700 : 400,
                }}
              >
                {commnd}
              </Typography>
            ))
          ) : (
            <Typography
              key={command[0]}
              sx={{
                ...cloudCommandsStyles.commandBox,
                color:
                  command?.[1] === 200
                    ? 'green'
                    : command?.[1] === null
                    ? 'black'
                    : 'red',
                fontWeight: command?.[1] === null ? 700 : 400,
              }}
            >
              {command[0]}
            </Typography>
          ),
        )}
      </Stack>
    </Stack>
  );
};

export default CloudCommands;
